import { getHostName } from '../config/env';
import { assignHref, getHref } from './location';

const redirectToLogin = (): void => {
  const url = `https://login.${getHostName()}.com`;
  assignHref(`${url}?origin=${getHref()}`);
};

const redirectToDashboard = (): void => {
  assignHref(`https://${getHostName()}.com`);
};

export { redirectToLogin, redirectToDashboard };
